import { XStack, YStack } from '@shinetools/lumen-react'

import { Amount } from './elements/Amount'
import { BillsList } from './elements/BillsList'

interface SupplierBillInformationProps {
  supplierId?: string
}

export const SupplierBillInformation = ({ supplierId }: SupplierBillInformationProps) => {
  return (
    <YStack gap={24}>
      <XStack gap={12}>
        <Amount supplierId={supplierId} />
      </XStack>
      <BillsList supplierId={supplierId} />
    </YStack>
  )
}
